import { type StateResponse } from '@on3/api';
import { slugify } from '@on3/ui-lib/utils/slugify';
import Link from 'next/link';

import styles from './StateRankings.module.scss';

interface StateRankingsProps {
  states: StateResponse[];
}

export const StateRankings = ({ states }: StateRankingsProps) => {
  return (
    <div className={styles.block}>
      <h2>High School State Rankings</h2>
      <ul aria-label="High School State Rankings" role="navigation">
        {states
          .filter((s) => s.key <= 51)
          .map((state) => {
            const name = state.name as string;

            const getStateName = (n: string) => {
              switch (n.toLowerCase()) {
                case 'district of columbia':
                  return 'DC';
                default:
                  return n;
              }
            };
            const stateSlug = slugify(name);

            return (
              <li key={state.key}>
                <Link href={`/high-school/rankings/football/${stateSlug}/`}>
                  {getStateName(name)}
                </Link>
              </li>
            );
          })}
      </ul>
    </div>
  );
};
